import * as React from "react";

import { Home } from "../components/home";

//export interface HomeProps { compiler: string; framework: string; }

export const HomePage = () => <Home />;